// Admin portal config
export const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://adm.hotspotstore.com'
    : 'http://localhost:8001');

// All images served from the backend (same domain as API)
export const IMAGE_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://adm.hotspotstore.com'
  : 'http://localhost:8001';

// Inline SVG placeholder — keeps previews offline-safe with no external requests.
const IMAGE_FALLBACK =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">' +
      '<rect width="80" height="80" fill="#F2F4F7"/>' +
      '<circle cx="30" cy="30" r="6" fill="#D0D5DD"/>' +
      '<path d="M14 60l16-20 12 15 9-10 15 15z" fill="#D0D5DD"/>' +
    '</svg>'
  );

export const getImageUrl = (path, fallback = IMAGE_FALLBACK) => {
  if (!path) return fallback;
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) return path;
  // Strip the old admin/rp domain prefix that stored procedures may include
  const stripped = path.replace(/^\/(admin\.hotspotstore\.com|rp\.hotspotstore\.com)/, '');
  const cleanPath = stripped.startsWith('/') ? stripped : `/${stripped}`;
  return `${IMAGE_BASE_URL}${cleanPath}`;
};
